import { Trigger as TabsTrigger } from "@radix-ui/react-tabs";
import { cn } from "@/lib/utils";

import type { TabsTriggerProps as RadixTabsTriggerProps } from "@radix-ui/react-tabs";

 type TabButtonProps = React.ComponentProps<"button"> &
  RadixTabsTriggerProps;

const TabButton: React.FC<TabButtonProps> = ({
  value,
  children,
  className,
  ...rest
}) => {
  return (
    <TabsTrigger
      value={value}
      className={cn(
        "cursor-pointer relative whitespace-nowrap not-italic text-center px-4 py-2 outline-none inline-flex justify-center items-center select-none shrink-0 border border-transparent transition-colors disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...rest}
    >
      {children}
    </TabsTrigger>
  );
};

export default TabButton;
